export const pad = (num) => (parseInt(num, 10) > 9 ? `${num}` : `0${num}`);

export const capitalize = (str = '') =>
  str.length > 0 ? `${str[0].toUpperCase()}${str.slice(1)}` : '';

export const mix = (x, y, a) => x * (1 - a) + y * a;

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
